import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

import { ContextMenuHandler } from './contextMenuHandler.js';
import { IContextViewService } from './contextView.js';
import { ITelemetryService } from '../../telemetry/common/telemetry.js';
import { Emitter } from '../../../base/common/event.js';
import { INotificationService } from '../../notification/common/notification.js';
import { IThemeService } from '../../theme/common/themeService.js';
import { IKeybindingService } from '../../keybinding/common/keybinding.js';
import { Disposable } from '../../../base/common/lifecycle.js';

var ContextMenuService = /*#__PURE__*/function (_Disposable) {
  _inherits(ContextMenuService, _Disposable);

  var _super = _createSuper(ContextMenuService);

  function ContextMenuService(telemetryService, notificationService, contextViewService, keybindingService, themeService) {
    var _this;

    _classCallCheck(this, ContextMenuService);

    _this = _super.call(this);
    _this._onDidContextMenu = _this._register(new Emitter());
    _this.onDidContextMenu = _this._onDidContextMenu.event;
    _this.contextMenuHandler = new ContextMenuHandler(contextViewService, telemetryService, notificationService, keybindingService, themeService);
    return _this;
  }

  _createClass(ContextMenuService, [{
    key: "configure",
    value: function configure(options) {
      this.contextMenuHandler.configure(options);
    } // ContextMenu

  }, {
    key: "showContextMenu",
    value: function showContextMenu(delegate) {
      this.contextMenuHandler.showContextMenu(delegate);

      this._onDidContextMenu.fire();
    }
  }]);

  return ContextMenuService;
}(Disposable);

ContextMenuService = __decorate([__param(0, ITelemetryService), __param(1, INotificationService), __param(2, IContextViewService), __param(3, IKeybindingService), __param(4, IThemeService)], ContextMenuService);
export { ContextMenuService };